/* eslint-disable react/prop-types */
import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import {
  Box,
  useMediaQuery,
  Breadcrumbs,
  Typography,
  IconButton,
  Tooltip,
  Menu,
  ListItem
  // Divider
} from '@mui/material';

import logo from '../../assets/images/logos/Main-Logo_Dashboard.svg';

import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import HomeIcon from '@mui/icons-material/Home';
import login_bg from '../../assets/images/logos/Dashboard_Background.png';
import './HeaderComponent.css';

export const BreadcumbBar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const pathFirstSegment = location.pathname.split('/').filter(x => x)[0];
  const session = location.state?.session?.split(':')[0].trim();
  const capitalizedSegment =
    pathFirstSegment?.charAt(0)?.toUpperCase() + pathFirstSegment?.slice(1);

  const pathnames = [];
  if (pathFirstSegment) pathnames?.push(capitalizedSegment);
  if (session) pathnames.push(session);
  const handleBreadcrumbClick = index => {
    if (index === 0) {
      navigate(`/${pathFirstSegment}`);
    }
  };

  return (
    <Box
      sx={{
        bgcolor: ' #ffffff',
        boxShadow: ` 0.3rem 0.3rem 0.5rem rgb(195 193 198 / 90%), -0.2rem -0.2rem 0.4rem rgb(195 193 198 / 90%)`,
        m: 0
      }}>
      <Box sx={{ ml: 10, display: 'flex', alignItems: 'center' }}>
        <HomeIcon
          // CKey-112: Hide navigation
          // onClick={() => navigate('/dashboard')}
          fontSize="medium"
          sx={{ mb: 0, mt: 0.3, cursor: 'pointer', color: '#124c72 !important' }}
        />
        <Typography
          sx={{
            mx: 1,
            fontSize: 'medium',
            fontWeight: 'bold',
            color: '#124c72'
          }}>
          /
        </Typography>
        <Breadcrumbs>
          {pathnames.map((value, index) => {
            const last = index === pathnames.length - 1;
            const displayValue = value?.replace('%20', ' ');
            return last ? (
              <Typography
                sx={{
                  fontSize: 'medium',
                  paddingLeft: '3px',
                  fontWeight: '100 !important',
                  color: '#grey !important'
                }}
                fontSize="medium"
                color="textPrimary"
                onClick={() => handleBreadcrumbClick(index)}
                key={index}>
                {displayValue}
              </Typography>
            ) : (
              <Typography
                sx={{
                  cursor: 'pointer',
                  fontSize: 'medium',
                  paddingLeft: '3px',
                  color: '#124c72 !important'
                }}
                color="inherit"
                onClick={() => handleBreadcrumbClick(index)}
                key={index}>
                {displayValue}
              </Typography>
            );
          })}
        </Breadcrumbs>
      </Box>
    </Box>
  );
};

export const UserIconButton = () => {
  const [anchorEl, setAnchorEl] = useState(null);

  const open = Boolean(anchorEl);
  const handleClick = event => {
    // console.log(event.currentTarget);
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  let padding = {
    paddingLeft: '20px !important',
    paddingRight: '30px !important',
    cursor: 'pointer',
    '&:hover': {
      color: 'steelblue'
    }
  };
  // let dividerProps = {
  //   margin: '10px !important',
  //   width: '90% !important',
  //   background: 'grey'
  // };
  const urlSwitch = env => {
    switch (env) {
      case 'development':
        return process.env.REACT_APP_React_DEVELOPMENT_URL;
      case 'test':
        return process.env.REACT_APP_React_TESTING_URL;
      case 'production':
        return process.env.REACT_APP_React_PRODUCTION_URL;
      default:
        return process.env.REACT_APP_React_DEVELOPMENT_URL;
    }
  };
  const Logout = () => {
    sessionStorage.removeItem('token');
    sessionStorage.removeItem('userid');
    sessionStorage.removeItem('department');
    sessionStorage.removeItem('description');
    sessionStorage.removeItem('descriptionformat');
    sessionStorage.removeItem('email');
    sessionStorage.removeItem('firstaccess');
    sessionStorage.removeItem('firstname');
    sessionStorage.removeItem('fullname');
    sessionStorage.removeItem('id');
    sessionStorage.removeItem('lastaccess');
    sessionStorage.removeItem('lastname');
    sessionStorage.removeItem('profileimageurl');
    sessionStorage.removeItem('profileimageurlsmall');
    sessionStorage.removeItem('suspended');
    sessionStorage.removeItem('username');
    sessionStorage.removeItem('userid');
    sessionStorage.removeItem('activityInstance');
    sessionStorage.removeItem('userEmail');
    localStorage.removeItem('UserData');
    localStorage.removeItem('group');
    localStorage.removeItem('id');
    localStorage.removeItem('token');
    localStorage.removeItem('userid');
    localStorage.removeItem('userId');
    localStorage.removeItem('activityInstance');
    localStorage.removeItem('userEmail');
    localStorage.removeItem('courseIdselected');

    if (localStorage.getItem('username')) {
      // Remove 'username' and redirect to the specified URL
      localStorage.removeItem('username');
      window.location.href = 'https://www.pescirrus.com/';
    } else if (sessionStorage.getItem('email') == null) {
      // If sessionStorage doesn't contain 'email', redirect to the base URL
      window.location.href = urlSwitch(process.env.REACT_APP_ENV);
      window.location.reload(false);
    }
  };
   /* CKey-112: Hiding Navigation */
   const navenable = sessionStorage.getItem('navigation') === 'true';
  return ( navenable && 
    <>
      <Tooltip sx={{ width: '100vw', paddingRight: '0 !important' }} title="Account settings">
        <IconButton onClick={handleClick} sx={{ p: 0, mr: '30px !important' }}>
          <AccountCircleIcon
            sx={{
              bgcolor: `#f7f9fc`,
              borderRadius: 10,
              cursor: 'pointer',
              width: '45px',
              height: '45px',
              color: '#124c72 !important'
            }}
            color="#124c72"
            fontSize="large"
          />
        </IconButton>
      </Tooltip>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        onClick={handleClose}
        sx={{
          paddingLeft: 0,
          width: '300px !important'
        }}
        PaperProps={{
          sx: {
            borderRadius: '10px !important',
            overflow: 'visible',
            mt: 1,
            '&::after': {
              content: `" "`,
              position: 'absolute',
              bottom: '100%',
              left: '90%',
              marginLeft: ' -10px',
              borderWidth: '10px',
              borderStyle: 'solid',
              borderColor: 'transparent transparent white transparent'
            }
          }
        }}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}>
        {/* <ListItem sx={padding}>
          <b>Home</b>
        </ListItem>
        <Divider sx={dividerProps} /> */}
        {/* <ListItem sx={padding}>
          <b>name</b>
        </ListItem>
        <Divider sx={dividerProps} />
        <ListItem sx={padding}>
          <b>email</b>
        </ListItem>
        <Divider sx={dividerProps} /> */}
        <ListItem sx={padding}>
          <button className="logoutButton" onClick={() => Logout()}>
            SIGN OUT
          </button>
        </ListItem>
      </Menu>
    </>
  );
};

const HeaderComponent = () => {
  const matches = useMediaQuery('(min-width:600px)');
  const navigate = useNavigate();
  //Ckey-112
  const navenable1 = sessionStorage.getItem('navigation') === 'true';
  const HeaderComp = () => (
    <Box
      sx={{
        py: 1,
        bgcolor: `#f7f9fc`,
        boxShadow: ` 0.3rem 0.3rem 0.5rem rgb(195 193 198 / 90%), -0.2rem -0.2rem 0.4rem rgb(195 193 198 / 90%)`,
        backgroundImage: `url(${login_bg}) !important`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover !important',
        backgroundPosition: 'top top',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center'
      }}>
      <img
        src={logo}
        alt="Logo"
        width={matches ? '350px' : '200px'}
        height={matches ? 40 : 40}
        style={{ marginLeft: 10 }}
        // CKey-112: Hide Navigation
       // onClick={() => navigate('/dashboard')}
        onClick={ navenable1 ? () => navigate('/dashboard') : undefined}
      />
      <UserIconButton />
    </Box>
  );

  return (
    <div
      style={{
        position: 'fixed',
        top: '0',
        width: '100%',
        zIndex: 1000
      }}>
      <HeaderComp />
      <BreadcumbBar />
    </div>
  );
};

//export default HeaderComponent;
export default HeaderComponent;
